import React from "react";
import { injectIntl } from "react-intl";
import { connect } from "react-redux";
import { compose } from "recompose";
import TableCell from "@material-ui/core/TableCell";
import Typography from "@material-ui/core/Typography";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import {
  sortSubscriberFieldSelector,
  sortSubscriberDirectionSelector,
} from "../../../redux/selectors";
import { setSubscriberSort } from "../../../redux/actions";

const SubscriberHeader = ({ intl, isDescending, changeSort, field }) => {
  return (
    <TableRow>
      <TableCell
        size="small"
        align="left"
        style={{ border: "none", padding: "6px 0px 6px 0px" }}
      />

      <TableCell align="left" sortDirection={false} style={{ border: "none" }}>
        <TableSortLabel
          active={field === "name"}
          direction={isDescending ? "desc" : "asc"}
          onClick={() => changeSort("name", !isDescending)}
          IconComponent={ExpandMoreIcon}
        >
          <Typography
            variant="subtitle1"
            style={{
              fontWeight: 400,
              letterSpacing: "2.08px",
              fontSize: "13px",
              lineHeight: "16px",
              color: "#011020",
              textTransform: "uppercase",
              minWidth: "200px",
            }}
          >
            {intl.formatMessage({ id: "app.subscribers.nameColumnLabel" })}
          </Typography>
        </TableSortLabel>
      </TableCell>
      <TableCell align="left" sortDirection={false} style={{ border: "none" }}>
        <TableSortLabel
          active={field === "sponsorName"}
          direction={isDescending ? "desc" : "asc"}
          onClick={() => changeSort("sponsorName", !isDescending)}
          IconComponent={ExpandMoreIcon}
        >
          <Typography
            variant="subtitle1"
            style={{
              fontWeight: 400,
              letterSpacing: "2.08px",
              fontSize: "13px",
              lineHeight: "16px",
              color: "#011020",
              textTransform: "uppercase",
            }}
          >
            {intl.formatMessage({
              id: "app.subscribers.sponsorNameColumnLabel",
            })}
          </Typography>
        </TableSortLabel>
      </TableCell>
      <TableCell align="left" sortDirection={false} style={{ border: "none" }}>
        <TableSortLabel
          active={field === "subscriptionExpires"}
          direction={isDescending ? "desc" : "asc"}
          onClick={() => changeSort("subscriptionExpires", !isDescending)}
          IconComponent={ExpandMoreIcon}
        >
          <Typography
            variant="subtitle1"
            style={{
              fontWeight: 400,
              letterSpacing: "2.08px",
              fontSize: "13px",
              lineHeight: "16px",
              color: "#011020",
              textTransform: "uppercase",
            }}
          >
            {intl.formatMessage({
              id: "app.subscribers.subscriptionExpirationDateColumnLabel",
            })}
          </Typography>
        </TableSortLabel>
      </TableCell>
      <TableCell align="left" sortDirection={false} style={{ border: "none" }}>
        <TableSortLabel
          active={field === "isOpenApiEnabled"}
          direction={isDescending ? "desc" : "asc"}
          onClick={() => changeSort("isOpenApiEnabled", !isDescending)}
          IconComponent={ExpandMoreIcon}
        >
          <Typography
            variant="subtitle1"
            style={{
              fontWeight: 400,
              letterSpacing: "2.08px",
              fontSize: "13px",
              lineHeight: "16px",
              color: "#011020",
              textTransform: "uppercase",
            }}
          >
            {intl.formatMessage({ id: "app.subscribers.apiColumnLabel" })}
          </Typography>
        </TableSortLabel>
      </TableCell>
      <TableCell align="left" style={{ border: "none" }}>
        <TableSortLabel
          active={field === "language"}
          direction={isDescending ? "desc" : "asc"}
          onClick={() => changeSort("language", !isDescending)}
          IconComponent={ExpandMoreIcon}
        >
          <Typography
            variant="subtitle1"
            style={{
              fontWeight: 400,
              fontSize: "13px",
              color: "#232c3b",
              textTransform: "uppercase",
            }}
          >
            {intl.formatMessage({ id: "app.general.languageLabel" })}
          </Typography>
        </TableSortLabel>
      </TableCell>
      <TableCell align="left" style={{ border: "none" }}>
        <TableSortLabel
          active={field === "jurisdictionName"}
          direction={isDescending ? "desc" : "asc"}
          onClick={() => changeSort("jurisdictionName", !isDescending)}
          IconComponent={ExpandMoreIcon}
        >
          <Typography
            variant="subtitle1"
            style={{
              fontWeight: 400,
              letterSpacing: "2.08px",
              fontSize: "13px",
              lineHeight: "16px",
              color: "#011020",
              textTransform: "uppercase",
            }}
          >
            {intl.formatMessage({ id: "app.subscribers.jurisdiction" })}
          </Typography>
        </TableSortLabel>
      </TableCell>
      <TableCell align="left" style={{ border: "none" }}>
        <TableSortLabel
          active={field === "isMFAEnabled"}
          direction={isDescending ? "desc" : "asc"}
          onClick={() => changeSort("isMFAEnabled", !isDescending)}
          IconComponent={ExpandMoreIcon}
        >
          <Typography
            variant="subtitle1"
            style={{
              fontWeight: 400,
              fontSize: "13px",
              color: "#232c3b",
              textTransform: "uppercase",
            }}
          >
            {intl.formatMessage({
              id: "app.userProfile.teamMemberTableMember2FAStateHeader",
            })}
          </Typography>
        </TableSortLabel>
      </TableCell>
      <TableCell align="left" style={{ border: "none" }}>
        <TableSortLabel
          active={field === "teamName"}
          direction={isDescending ? "desc" : "asc"}
          onClick={() => changeSort("teamName", !isDescending)}
          IconComponent={ExpandMoreIcon}
        >
          <Typography
            variant="subtitle1"
            style={{
              fontWeight: 400,
              letterSpacing: "2.08px",
              fontSize: "13px",
              lineHeight: "16px",
              color: "#011020",
              textTransform: "uppercase",
            }}
          >
            {intl.formatMessage({ id: "app.subscribers.teamLabel" })}
          </Typography>
        </TableSortLabel>
      </TableCell>
      <TableCell align="left" style={{ border: "none" }}>
        <TableSortLabel
          active={field === "circleCount"}
          direction={isDescending ? "desc" : "asc"}
          onClick={() => changeSort("circleCount", !isDescending)}
          IconComponent={ExpandMoreIcon}
        >
          <Typography
            variant="subtitle1"
            style={{
              fontWeight: 400,
              letterSpacing: "2.08px",
              fontSize: "13px",
              lineHeight: "16px",
              color: "#011020",
              textTransform: "uppercase",
            }}
          >
            {intl.formatMessage({ id: "app.subscribers.circleCountLabel" })}
          </Typography>
        </TableSortLabel>
      </TableCell>

      <TableCell align="left" style={{ border: "none" }}>
        <TableSortLabel
          active={field === "lastLoginSeconds"}
          direction={isDescending ? "desc" : "asc"}
          onClick={() => changeSort("lastLoginSeconds", !isDescending)}
          IconComponent={ExpandMoreIcon}
        >
          <Typography
            variant="subtitle1"
            style={{
              fontWeight: 400,
              letterSpacing: "2.08px",
              fontSize: "13px",
              lineHeight: "16px",
              color: "#011020",
              textTransform: "uppercase",
            }}
          >
            {intl.formatMessage({ id: "app.subscribers.lastLoginLabel" })}
          </Typography>
        </TableSortLabel>
      </TableCell>
      <TableCell
        align="left"
        style={{ width: "10px", padding: "6px 0px 6px 0px", border: "none" }}
      />
    </TableRow>
  );
};

const mapStateToProps = (state) => ({
  isDescending: sortSubscriberDirectionSelector(state),
  field: sortSubscriberFieldSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  changeSort: (field, direction) =>
    dispatch(setSubscriberSort(field, direction)),
});

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  injectIntl,
);

export default enhance(SubscriberHeader);
